import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, findAll, getParent } from '@fretadao/f-js-dom';
import { uniq, isBlank, isPresent } from '@fretadao/f-js-utils';

application.register(
  'line-schedule-requests-form-lines-date',
  class extends Controller {
    static targets = ['requestType', 'firstTravelDate', 'lastTravelDate'];

    update() {
      if(this.requestTypeTarget.value === 'time_change') this.#removeFieldsForSearchLines();
      else this.#addFieldsForSearchLines();

      ['#mobile-table-lines-filter', '#desktop-table-lines-filter'].forEach((tableId) => {
        findAll(tableId).forEach((table) => this.#updateLabelFromTable(table));
      });
    }

    #updateLabelFromTable(table) {
      findAll('[id^=days-of-change]', table).forEach((cell) => {
        cell.textContent = this.#travelDateFormatted();
      });
    }

    #travelDateFormatted() {
      const firstDate = new Date(this.firstTravelDateTarget.value);
      const lastDate = new Date(this.lastTravelDateTarget.value);
      const formatter = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'UTC' });

      return uniq([formatter.format(firstDate), formatter.format(lastDate)]).join(' à ');
    }

    #copyToHiddenField({ fieldName, originalField }) {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = fieldName;
      hiddenField.value = originalField.value;

      return hiddenField;
    }

    #addFieldsForSearchLines() {
      if(isBlank(this.#linesFormBox())) return;

      const requestType = this.#copyToHiddenField({ fieldName: 'request_type', originalField: this.requestTypeTarget });
      const firstTravelDate = this.#copyToHiddenField({ fieldName: 'first_travel_date', originalField: this.firstTravelDateTarget });
      const lastTravelDate = this.#copyToHiddenField({ fieldName: 'last_travel_date', originalField: this.lastTravelDateTarget });

      this.#removeFieldsForSearchLines();

      const lineFilterForm = this.#lineFilterForm();
      [requestType, firstTravelDate, lastTravelDate].forEach(field => lineFilterForm.prepend(field));
    }

    #lineFilterForm() {
      return find('form', this.#linesFormBox());
    }

    #linesFormBox() {
      return getParent(this.element).nextElementSibling;
    }

    #fieldsForSearchLines() {
      const lineFilterForm = this.#lineFilterForm();
      const fieldNames = ['request_type', 'first_travel_date', 'last_travel_date'];

      return fieldNames.map(fieldName => find(`input[name="${fieldName}"]`, lineFilterForm)).filter(isPresent);
    }

    #removeFieldsForSearchLines() {
      this.#fieldsForSearchLines().forEach(field => field.remove())
    }
  }
);
